function debounce(callback, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(function () { callback.apply(this, args); }, wait);
  };
}

window.addEventListener('trix-initialize', function(event) {
  const $input = $(event.path[0]); // current container
  const $form = $input.closest('.note-form');

  if (!$form.length) return;

  const type = $form.data('type');
  const typeId = $form.data('type-id');
  const id = $form.data('note-id');
  const storageKey = `[${type}][${typeId}][${id}]`

  const $trix = $(document.querySelector('trix-editor'));
  const draft = localStorage.getItem(storageKey);

  if (draft && draft.length) {
    event.target.editor.loadJSON(JSON.parse(draft));
  }

  $trix.on('trix-change', debounce( (event) => {
    localStorage.setItem(storageKey, JSON.stringify(event.currentTarget.editor));
  }, 500));
});

$(document).on('ready turbolinks:load', function() {
  const $body = $('body');

  $body.on('trix:note:create:success', (event, eventObj) => {
    const { type, typeId } = JSON.parse(eventObj);

    const storageKey = `[${type}][${typeId}][undefined]`
    localStorage.removeItem(storageKey);
  });

  $body.on('trix:note:update:success', (event, eventObj) => {
    const { type, typeId, id } = JSON.parse(eventObj);

    const storageKey = `[${type}][${typeId}][${id}]`
    localStorage.removeItem(storageKey);
  });
});
